import type { Moment } from "moment";

import { SAVE_DATE_FORMAT } from "@/v1/constants";
import { getBerlinMomentTimezone } from "@/v1/components/common/helpers";

/**
 * Maps the FiBu start date DatePicker value to the payload sent to `editUser`.
 *
 * An empty value (the DatePicker was cleared via `allowClear`) maps to `null`
 * so the backend clears the field. Without this branch an empty value would
 * fall through to `getBerlinMomentTimezone(undefined)`, which resolves to the
 * current time and would silently re-set the field to today. See SMT-1248.
 */
export const getFibuStartDateSaveValue = (
  value: Moment | null | undefined
): string | null =>
  value
    ? getBerlinMomentTimezone(value.format(SAVE_DATE_FORMAT)).toISOString()
    : null;
